import { styled } from '@mui/material';
import { forwardRef, useState } from 'react';
import IconButton from 'shell/components/IconButton';
import TextInput from 'shell/components/TextInput';

const CustomIconButton = styled(IconButton)(({ theme }) => {
    return {
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '-5px',
        },
    };
});

const PasswordInput = forwardRef((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextInput
            ref={ref}
            disablePointerEventsOnIcon={false}
            endIcon={
                <CustomIconButton
                    aria-label={'toggle password visibility'}
                    kind={showPassword ? 'hide' : 'visible'}
                    variant={'square'}
                    onClick={() => setShowPassword((current) => !current)}
                    onMouseDown={(e) => e.preventDefault()}
                />
            }
            type={showPassword ? 'text' : 'password'}
            {...props}
        />
    );
});

export default PasswordInput;
